import React from "react";

export default class Url extends React.Component {
  static get url() {
    return "https://api.ketabno.com/api/";
  }
  /*****************LANDING**********************/

  static get GetMenu() {
    return this.url + "Landing/GetMenu";
  }
  static get GetGift() {
    return this.url + "Landing/GetGift";
  }
  static get GetIntroduce() {
    return this.url + "Landing/GetIntroduce";
  }
  static get GetSocialMedia() {
    return this.url + "Landing/GetSocialMedia";
  }
  static get GetStatistics() {
    return this.url + "Landing/GetStatistics";
  }
  static get GetFAQ() {
    return this.url + "Landing/GetFAQ";
  }
  static get GetMedia() {
    return this.url + "Landing/GetMedia";
  }
  static get GetSupporters() {
    return this.url + "Landing/GetSupporters";
  }
  static get GetComrade() {
    return this.url + "Landing/GetComrade";
  }
  static get GetSiteSetting() {
    return this.url + "Landing/GetSiteSetting";
  }

  /*****************LOGIN**********************/

  static get Login_User() {
    return this.url + "Identity/Login";
  }
  static get Confirm_Login() {
    return this.url + "Identity/ConfirmLogin";
  }
  static get Logout() {
    return this.url + "Identity/Logout";
  }
  /*****************Book**********************/
  static get ShadRegister() {
    return this.url + "Register";
  }
  /*****************Book**********************/
  static get Get_Books() {
    return this.url + "Book/GetBooks";
  }
  static get Get_GetOneBook() {
    return this.url + "Book/GetOneBook";
  }
  static get GetLastPost() {
    return this.url + "Book/GetLastPost";
  }
  static get AddBookRate() {
    return this.url + "Book/AddBookRate";
  }
  static get AddBookRead() {
    return this.url + "Book/AddBookRead";
  }
  static get AddBookComment() {
    return this.url + "Book/AddBookComment";
  }
  /*****************Campaigns**********************/
  static get GetCampaigns() {
    return this.url + "Campaign/GetCampaigns";
  }
  static get GetOneCampaign() {
    return this.url + "Campaign/GetOneCampaign";
  }
  /*****************Cart**********************/
  static get GetCart() {
    return this.url + "Cart/GetCart/GetCart";
  }
  static get AddCart() {
    return this.url + "Cart/AddCart/AddCart";
  }
  static get DeleteCart() {
    return this.url + "Cart/DeleteCart/DeleteCart";
  }
  static get DeleteAll() {
    return this.url + "Cart/DeleteAllCart";
  }

  /*****************Exam**********************/
  static get GetExam() {
    return this.url + "Exam/GetExam/GetExam";
  }
  static get AddExam() {
    return this.url + "Exam/AddExam/AddExam";
  }
  /*****************Actions**********************/

  static get GetActions() {
    return this.url + "Action/GetActions";
  }
  static get AddAction() {
    return this.url + "Action/AddAction";
  }

  /*****************Forum**********************/

  static get HomeForum() {
    return this.url + "Forum/GetHomeForum";
  }
  static get OneBookForum() {
    return this.url + "Forum/GetOneBookForum";
  }
  static get OneBookForumActions() {
    return this.url + "Forum/GetOneBookForumActions";
  }
  static get Informations() {
    return this.url + "Forum/GetInformations";
  }
  static get News() {
    return this.url + "Forum/GetNews";
  }
  static get TermsAndConditions() {
    return this.url + "Forum/GetTermsAndConditions";
  }
  static get TermsOfUses() {
    return this.url + "Forum/GetTermsOfUses";
  }
  static get FrequentlyQuestions() {
    return this.url + "Forum/GetFrequentlyQuestions";
  }
  static get Helps() {
    return this.url + "Forum/GetHelps";
  }
  static get CommonQuestions() {
    return this.url + "Forum/GetCommonQuestions";
  }
  static get GetInformations() {
    return this.url + "Forum/GetInformations";
  }
  static get GetKetabLogs() {
    return this.url + "Forum/GetKetablogs";
  }
  static get GetOneKetabLog() {
    return this.url + "Forum/GetOneKetablog";
  }
  // ===================================================
  static get Topics() {
    return this.url + "Forum/Topics";
  }
  static get Posts() {
    return this.url + "Forum/Posts";
  }
  static get Comments() {
    return this.url + "Forum/Comments";
  }
  static get AddPost() {
    return this.url + "Forum/AddPost";
  }
  static get AddComment() {
    return this.url + "Forum/AddComment";
  }
  static get AddPostLike() {
    return this.url + "Forum/AddPostLike";
  }
  static get AddPostReport() {
    return this.url + "Forum/AddPostReport";
  }
  static get AddPostRate() {
    return this.url + "Forum/AddPostRate";
  }

  /*****************Profile**********************/
  static get GetInvitees() {
    return this.url + "Profile/GetInvitees";
  }
  static get SendInvite() {
    return this.url + "Profile/Invite";
  }
  static get GetMyBooks() {
    return this.url + "Profile/GetMyBooks";
  }
  static get GetMyComments() {
    return this.url + "Profile/GetMyComments";
  }
  static get GetUserInfo() {
    return this.url + "Profile/GetUserInfo";
  }
  static get GetProfile() {
    return this.url + "Profile/GetProfile";
  }
  static get GetUserProfile() {
    return this.url + "Forum/GetUserProfile";
  }
  static get GetOnlineChats() {
    return this.url + "Profile/GetOnlineChats";
  }
  static get AddOnlineChat() {
    return this.url + "Profile/AddOnlineChat";
  }
  static get GetOfferedPriceForCharge() {
    return this.url + "Profile/GetOfferedPriceForCharge";
  }
  static get GetTransfers() {
    return this.url + "Profile/GetTransfers";
  }
  static get ChargeWallet() {
    return this.url + "Profile/ChargeWallet";
  }
  static get TransferWallet() {
    return this.url + "Profile/TransferWallet";
  }
  static get UpdateUserInfo() {
    return this.url + "Profile/UpdateUserInfo";
  }
  static get GetProvinces() {
    return this.url + "Profile/GetProvinces";
  }
  static get GetCities() {
    return this.url + "Profile/GetCities";
  }
  static get GetCommonQuestions() {
    return this.url + "Profile/GetCommonQuestions";
  }
  static get GetMyActivity() {
    return this.url + "Profile/GetMyActivity";
  }
  static get GetSavePosts() {
    return this.url + "Profile/GetSavePosts";
  }
  static get DeleteSavePost() {
    return this.url + "Profile/DeleteSavePost";
  }
  static get GetAwardRecieved() {
    return this.url + "Profile/GetAwardRecieved";
  }
  static get AddSavePost() {
    return this.url + "Profile/AddSavePost";
  }
  /*****************Action**********************/
  static get GetActions() {
    return this.url + "Action/GetActions";
  }
  static get GetMyComments() {
    return this.url + "Action/AddAction";
  }
  /*****************Payment**********************/
  static get CheckDiscountCode() {
    return this.url + "Payment/CheckDiscountCode";
  }
  static get PaymentRequest() {
    return this.url + "Payment/PaymentRequest";
  }
  static get VerifyPayment() {
    return this.url + "Payment/VerifyPayment";
  }
  static get ChargeWalletRequest() {
    return this.url + "Payment/ChargeWalletRequest";
  }
  static get VerifyChargeWallet() {
    return this.url + "Payment/VerifyChargeWallet";
  }
  static get getLastPaymentUrl() {
    return this.url + "Payment/GetLastPayment";
  }
  static get getLastChargeUrl() {
    return this.url + "Payment/GetLastCharge";
  }
  /*****************system message**********************/
  static get GetSystemMessages() {
    return this.url + "SystemMessages/GetSystemMessages/GetSystemMessages";
  }
  /*****************Club**********************/
  static get GetHomeClub() {
    return this.url + "Club/GetHomeClub/GetHomeClub";
  }
  static get GetBestOfCampaign() {
    return this.url + "Club/GetBestOfCampaign/GetBestOfCampaign";
  }
  static get GetMostLike() {
    return this.url + "Club/GetMostLike/GetMostLike";
  }
  static get GetMostInvite() {
    return this.url + "Club/GetMostInvite/GetMostInvite";
  }
  static get GetBestMedalists() {
    return this.url + "Club/GetBestMedalists/GetBestMedalists";
  }
  static get GetMyCoins() {
    return this.url + "Club/GetMyCoins/GetMyCoins";
  }
  static get GetMyScores() {
    return this.url + "Club/GetMyScores/GetMyScores";
  }
  static get GetMyMedals() {
    return this.url + "Club/GetMyMedals/GetMyMedals";
  }
  static get GetMySigns() {
    return this.url + "Club/GetMySigns/GetMySigns";
  }
  static get GetCoinHelps() {
    return this.url + "Club/GetCoinHelps/GetCoinHelps";
  }
  static get GetScoreHelps() {
    return this.url + "Club/GetScoreHelps/GetScoreHelps";
  }
  static get GetMedalHelps() {
    return this.url + "Club/GetMedalHelps/GetMedalHelps";
  }
  static get GetSignHelps() {
    return this.url + "Club/GetSignHelps/GetSignHelps";
  }
  static get GetAwardCategories() {
    return this.url + "Club/GetAwardCategories/GetAwardCategories";
  }
  static get GetAwards() {
    return this.url + "Club/GetAwards/GetAwards";
  }
  static get TakeAward() {
    return this.url + "Club/AddAward/GetAwards";
  }
  static get GoldBox() {
    return this.url + "Club/AddGoldBox/AddGoldBox";
  }
  /*****************physical books**********************/
  static get GetAvailableBooks() {
    return this.url + "PhysicalBooks/GetAvailableBooks";
  }
  static get GetPhysicalBookBuys() {
    return this.url + "PhysicalBooks/GetPhysicalBookBuys";
  }
  static get AddPhysicalBookBuy() {
    return this.url + "PhysicalBooks/AddPhysicalBookBuy";
  }

  // /////////////////////////////////////////////////////////////

  static get GetGrades() {
    return this.url + "Profile/GetGrades";
  }
  static get GetSchoolTypes() {
    return this.url + "Profile/GetSchoolTypes";
  }
  static get GetSchools() {
    return this.url + "Profile/GetSchools";
  }
  static get GetMethodOfIntroductions() {
    return this.url + "Profile/GetMethodOfIntroductions";
  }
  static get GetSupports() {
    return this.url + "Profile/GetSupports";
  }

  /*****************legate**********************/
  static get GetLegateProfileUrl() {
    return this.url + "Legate/GetLegateProfile";
  }
  static get GetLegateOrganiztionsUrl() {
    return this.url + "Legate/GetLegateOrganiztions";
  }
  static get AddLegateProfileUrl() {
    return this.url + "Legate/AddLegateProfile";
  }
  static get GetMyLegateUrl() {
    return this.url + "Legate/GetMyLegate";
  }
  static get GetBestLegateUrl() {
    return this.url + "Legate/GetBestLegate";
  }
  static get AddLegateInviteUrl() {
    return this.url + "Legate/AddLegateInvite";
  }
  static get GetTermAndConditionUrl() {
    return this.url + "Legate/GetTermAndConditions";
  }

  /***************** plus Exam **********************/
  static get GetNumberPlusExamsUrl() {
    return this.url + "PlusExams/GetNumberOfExamUser";
  }
  /***************** tv Exam **********************/
  static get GetTvExamsUrl() {
    return this.url + "TvExams/GetTvExams";
  }
  static get GetOneTvExamurl() {
    return this.url + "TvExams/GetOneTvExam";
  }
  static get AddTvExamUrl() {
    return this.url + "TvExams/AddExam";
  }

  /***************** knowledge Exam **********************/
  static get GetKnowledgeExamsUrl() {
    return this.url + "PlusExams/GetPlusExams";
  }
  static get GetOneKnowledgeExamurl() {
    return this.url + "PlusExams/GetOnePlusExam";
  }
  static get AddKnowledgeExamUrl() {
    return this.url + "PlusExams/AddExam";
  }
}
